<div
  role="navigation"
  class="sidebar"
  [ngClass]="{ 'sidebar--collapsed': isCollapsed }">
  <!-- TODO: break into components/tempates/zones [ future release ] -->

  <!-- sidebar / header -->
  <div class="sidebar__header">
    <div class="sidebar__header-logo">
      <img class="image image--responsive" [src]="logoUrl" />
    </div>
  </div>

  <!-- sidebar / content -->
  <div class="sidebar__content">
    <!-- nav / sections -->
    <ng-container *ngFor="let section of items">
      <ul class="sidebar-nav">
        <!-- nav / items -->
        <ng-container *ngFor="let item of section">
          <li class="sidebar-nav__item" *ngIf="item.visibility !== 'hide'">
            <a
              class="nav-link"
              [routerLink]="
                item.visibility === 'show' ? item.href : 'coming-soon'
              "
              routerLinkActive="nav-link--active"
              [attr.data-testid]="item.name">
              <!-- item / icon -->
              <div class="nav-link__icon">
                <!-- choose icon template -->
                <ng-container
                  [ngTemplateOutlet]="isCollapsed ? tplIconTooltip : tplIcon"
                  [ngTemplateOutletContext]="{ item: item }">
                </ng-container>
              </div>

              <!-- item / label -->
              <div class="nav-link__label">
                {{ item.name }}
              </div>
            </a>
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </div>

  <!-- sidebar / footer -->
  <div class="sidebar__footer">
    <ul class="sidebar-nav m-none p-none">
      <li class="sidebar-nav__item">
        <a class="nav-link" (click)="onToggleCollapse()">
          <div class="nav-link__icon">
            <lds-icon
              [name]="isCollapsed ? 'arrow-line-right' : 'arrow-line-left'"
              appearance="inherit"></lds-icon>
          </div>
          <div class="nav-link__label">Collapse</div>
        </a>
      </li>
    </ul>
  </div>
</div>

<!-- templates -->

<!-- tpl / icon with tooltip -->
<ng-template #tplIconTooltip let-item="item">
  <lds-tooltip [message]="item.name" placement="right">
    <ng-container
      [ngTemplateOutlet]="tplIcon"
      [ngTemplateOutletContext]="{ item: item }"></ng-container>
  </lds-tooltip>
</ng-template>

<!-- tpl / icon -->
<ng-template #tplIcon let-item="item">
  <lds-icon
    [name]="item.icon"
    appearance="inherit"
    [variation]="item.selected ? 'solid' : 'outline'">
  </lds-icon>
</ng-template>
